import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Package, Users, FileText, Receipt, Wallet, BarChart3, Settings, Menu, Cpu,
} from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { useApp } from "@/context/AppCtx";

const NAV = [
  ["", "Panel", LayoutDashboard],
  ["inventario", "Inventario", Package],
  ["clientes", "Clientes", Users],
  ["proformas", "Proformas", FileText],
  ["facturas", "Facturas", Receipt],
  ["cuentas-por-cobrar", "Cuentas por cobrar", Wallet],
  ["reportes", "Reportes", BarChart3],
  ["configuracion", "Configuración", Settings],
];

export const Brand = () => {
  const { settings } = useApp();
  return (
    <div className="flex items-center gap-3 px-5 py-6" data-testid="brand">
      {settings.logo ? (
        <img src={settings.logo} alt="Logo" className="w-11 h-11 rounded-xl object-contain bg-white/5 p-1" />
      ) : (
        <div className="w-11 h-11 rounded-xl btn-neon flex items-center justify-center">
          <Cpu className="w-6 h-6" />
        </div>
      )}
      <div className="min-w-0">
        <div className="font-display font-bold text-white text-sm leading-tight truncate">{settings.company_name}</div>
        <div className="text-[11px] text-slate-400 leading-tight line-clamp-2">{settings.slogan}</div>
      </div>
    </div>
  );
};

const NavLinks = ({ onNav }) => {
  const { base } = useApp();
  return (
    <nav className="px-3 space-y-1">
      {NAV.map(([to, label, Icon]) => (
        <NavLink
          key={label}
          end={to === ""}
          to={to ? `${base}/${to}` : base}
          onClick={onNav}
          data-testid={`nav-${to || "panel"}`}
          className={({ isActive }) =>
            `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${
              isActive
                ? "bg-gradient-to-r from-[#00F0FF]/20 to-[#9D4EDD]/20 text-[#00F0FF] border-l-4 border-[#00F0FF]"
                : "text-slate-400 hover:text-white hover:bg-[#1A143D]"
            }`
          }
        >
          <Icon className="w-4 h-4" />
          {label}
        </NavLink>
      ))}
    </nav>
  );
};

export const Sidebar = () => (
  <aside className="hidden lg:flex flex-col fixed inset-y-0 left-0 w-64 bg-[#0C0822]/90 border-r border-[#271E56] backdrop-blur-xl z-30">
    <Brand />
    <NavLinks />
  </aside>
);

export const MobileBar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="lg:hidden sticky top-0 z-30 flex items-center justify-between bg-[#0C0822]/85 backdrop-blur-xl border-b border-[#271E56] pr-3">
      <Brand />
      <button
        className="p-2 rounded-lg text-slate-300 hover:bg-[#1A143D]"
        onClick={() => setOpen(true)}
        data-testid="mobile-menu-btn"
        aria-label="Menú"
      >
        <Menu className="w-6 h-6" />
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-72 bg-[#0C0822] border-[#271E56] p-0">
          <SheetTitle className="sr-only">Menú</SheetTitle>
          <Brand />
          <NavLinks onNav={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
    </header>
  );
};
